import { AddressService } from 'src/app/feature/payment/services';
import { Component, Input, OnInit } from '@angular/core';
import { Address } from 'src/app/core';

@Component({
  selector: 'app-addresses',
  templateUrl: './addresses.component.html',
  styleUrls: ['./addresses.component.scss'],
})
export class AddressesComponent implements OnInit {
  @Input('address') address!: Address;

  constructor(private addressService: AddressService) {}
  ngOnInit(): void {}

  addAddress() {
    this.addressService.openAddressAddDialogBox();
  }
}
